var EPriceSize;

(function (EPriceSize) {
  EPriceSize["LARGE"] = "large";
  EPriceSize["MEDIUM"] = "medium";
  EPriceSize["SMALL"] = "small";
})(EPriceSize || (EPriceSize = {}));

var EPriceVariant;

(function (EPriceVariant) {
  EPriceVariant["CAMPAIGN"] = "Kampanj";
  EPriceVariant["KLIPP"] = "Klipp!";
  EPriceVariant["PRIO"] = "PRIO-pris";
  EPriceVariant["REGULAR"] = "Ordinarie";
})(EPriceVariant || (EPriceVariant = {}));

export { EPriceSize, EPriceVariant };